/** @jsxImportSource @emotion/react */
import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import Toast from 'components/atoms/Toast'
import {
  changedPaymentDetailsBody,
  DateField,
  Field,
  PAYMENT_METHOD_OPTIONS,
  PaymentDetailsDraft,
  PaymentMethodDetailsFields,
  validatePaymentDetailsDraft,
} from './PaymentMethodDetailsFields'

interface Props {
  values: PaymentDetailsDraft
  onDone: (values: PaymentDetailsDraft) => void
  onClose: () => void
}

// Edits a copy: Done hands it back to the row, whose Save sends it; Cancel drops it.
export const PaymentDetailsModal: React.FC<Props> = ({ values, onDone, onClose }) => {
  const [draft, setDraft] = React.useState(values)
  const set = (field: string, value: string) => setDraft((current) => ({ ...current, [field]: value }))
  const layout = { columnClassName: 'col-6', compact: false }

  const done = () => {
    if (!changedPaymentDetailsBody(draft, values)) {
      onClose()
      return
    }

    const error = validatePaymentDetailsDraft(draft)

    if (error) {
      Toast({ type: 'error', label: error })
      return
    }

    onDone(draft)
  }

  return (
    <Modal show onHide={onClose} centered size="lg">
      <Modal.Header>
        <Modal.Title css={{ fontSize: '1.1rem' }}>Payment details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row" css={{ rowGap: '0.75rem' }}>
          <DateField {...layout} label="Payment date" value={draft.paymentDate} onChange={(value) => set('paymentDate', value)} />
          <Field {...layout} label="Payment method">
            <select
              className="form-control"
              value={draft.paymentMethod}
              onChange={(event) => set('paymentMethod', event.target.value)}>
              {PAYMENT_METHOD_OPTIONS.map((option) => (
                <option key={option.key} value={option.key}>{option.value}</option>
              ))}
            </select>
          </Field>
          <PaymentMethodDetailsFields {...layout} values={draft} setFieldValue={set} />
        </div>
        <div css={{ color: '#6c757d', fontSize: '0.813rem', marginTop: '0.75rem' }}>
          Applies to every line this payment was posted to. Saved with the row.
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" size="sm" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" size="sm" onClick={done}>
          Done
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
